export function PdfRecoveryNotice() {
  return (
    <div
      role="status"
      className="relative z-20 mb-4 rounded-lg border bg-muted/40 p-4 text-sm"
    >
      <p className="font-medium">Replace this PDF to continue</p>
      <p className="mt-1 text-muted-foreground">
        This PDF couldn’t be read. Paste its text or add a link to a PDF with
        selectable text.
      </p>
      <a
        href={`${
          process.env.REACT_APP_WEBSITE_URL || "https://wavegen.ai"
        }/pdf-to-carousel`}
        className="mt-2 inline-block font-medium underline underline-offset-4"
      >
        Upload another PDF
      </a>
    </div>
  );
}
